<template>
    <article class="cmp cmp-product-thumb" :data-testing="item.variation.id">
        <div>
          <!-- image und name -->
          <div class="box-shadow">
              <div class="thumb-image">
                  <div class="prop-1-1">
                      <slot name="item-image">

                          <category-image-carousel :image-urls-data="item.images | itemImages(imageUrlAccessor)"
                                                  :alt="item | itemName"
                                                  :item-url="item | itemURL(urlWithVariationId)"
                                                  :enable-carousel="false"
                                                  :disable-carousel-on-mobile="true"
                                                  ref="categoryImageCarousel">
                          </category-image-carousel>
                      </slot>
                  </div>
                  <template v-if="stoffparent != null">
                      <span class="producer">
                          {{ $translate("Stoffe::Template.catManyColors") }}
                      </span>
                  </template>
                  <template v-else-if="showproducer != null">
                      <span class="producer">
                          {{ $translate("Stoffe::Template.singleAuthor") }} {{ showproducer }}
                      </span>
                  </template>
              </div>
              <!-- STORE SPECIALS -->
              <template v-if="isSoldOut">
                  <div class="special-tags">
                      <span class="badge badge-offer badge-danger">
                          {{ $translate("Stoffe::Template.globalCatAusverkauft") }}
                      </span>
                  </div>
              </template>
              <template v-else>
                  <slot name="store-special">
                      <item-store-special v-if="storeSpecial || item.variation.bundleType === 'bundle' || item.item.itemType === 'set'"
                                          :store-special="storeSpecial"
                                          :recommended-retail-price="item.prices.rrp"
                                          :variation-retail-price="item.prices.default"
                                          :special-offer-price="item.prices.specialOffer"
                                          :decimal-count="decimalCount"
                                          :bundle-type="item.variation.bundleType"
                                          :item-type="item.item.itemType">
                      </item-store-special>
                  </slot>
              </template>
              <!-- ./STORE SPECIALS -->

              <!-- ITEM DETAILS -->
              <div class="thumb-content">
                  <a :href="item | itemURL(urlWithVariationId)" class="thumb-title" :class="{ 'stretched-link': $ceres.config.global.shippingCostsCategoryId == 0 }">
                      {{ item | itemName }}<!--
                  --><span v-for="attribute in item.groupedAttributes">{{ "Ceres::Template.itemGroupedAttribute" | translate(attribute) }}</span>
                  </a>
              </div>
            </div>
          <!-- image und name ende -->
          <div class="thumb-meta mt-2">
            <slot name="before-prices"></slot>

            <div class="prices">
              <div v-if="item.prices.rrp && item.prices.rrp.price.value > 0 && item.prices.rrp.price.value > item.prices.default.price.value" class="price-view-port">
                <del class="crossprice" v-if="item.prices.specialOffer">
                  {{ item.prices.default.unitPrice.formatted | itemCrossPrice(true) }}
                </del>
                <del class="crossprice" v-else>
                  {{ item.prices.rrp.unitPrice.formatted | itemCrossPrice }}
                </del>
              </div>

              <div class="price">
                <template v-if="item.item.itemType === 'set'">
                  {{ $translate("Ceres::Template.itemSetPrice", { price: itemSetPrice }) }} {{ $translate("Ceres::Template.itemFootnote") }}
                </template>
                <template v-else-if="itemGraduatedPriceisCheapestSorting">
                  {{ $translate("Ceres::Template.itemFromPrice", { price: itemPriceGraduated }) }} {{ $translate("Ceres::Template.itemFootnote") }}
                </template>
                <template v-else-if="itemGraduatedPricesalableVariationCount">
                  {{ $translate("Ceres::Template.itemFromPrice", { price: itemPriceGraduated }) }} {{ $translate("Ceres::Template.itemFootnote") }}
                </template>
                <template v-else>
                  {{ item.prices.default.unitPrice.formatted | specialOffer(item.prices, "unitPrice", "formatted") }} {{ $translate("Ceres::Template.itemFootnote") }}
                </template>
              </div>
            </div>
          </div>

          <slot name="after-prices"></slot>

          <div class="category-lowest-price small" v-if="item.prices.default.lowestPrice.value && hasCrossPrice">
            <span v-html="$translate('Ceres::Template.itemLowestPrice', {'price': item.prices.default.lowestPrice.formatted})"></span>
          </div>

          <div class="category-unit-price small" v-if="!(item.unit.unitOfMeasurement === 'C62' && item.unit.content === 1)">
            <span>{{ item.unit.content }}</span>
            <span>&nbsp;{{ item.unit.names.name }}</span>
            <span v-if="item.variation.mayShowUnitPrice">&nbsp;| {{ basePrice }}</span>
          </div>


            <!-- ./ITEM DETAILS  -->
        </div>
    </article>
</template>

<script>
import { mapState } from "vuex";
import CategoryImageCarousel from "../components/itemList/CategoryImageCarousel.vue";
import ItemStoreSpecial from "../components/itemList/ItemStoreSpecial.vue";
import {getSlotData} from "../helper/getSlotData";

export default {
    components: {
        CategoryImageCarousel,
        ItemStoreSpecial
    },

    data()
    {
        return {
            stoffparent: null
        };
    },

    props: {
        decimalCount:
        {
            type: Number,
            default: 0
        },
        imageUrlAccessor:
        {
            type: String,
            default: "urlSecondPreview"
        },
        itemData:
        {
            type: Object
        },
        disableCarouselOnMobile:
        {
            type: Boolean
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        },
        forceUrlWithVariationId:
        {
            type: Boolean,
            default: false
        }
    },

    jsonDataFields: [
        "itemDataRef"
    ],

    created()
    {
        this.stoffparentCalc();
    },

    methods:
    {
        stoffparentCalc()
        {
            const itemInfo = this.item;
            if (itemInfo && itemInfo.hasOwnProperty('tags'))
            {
                for (let i = 0; i < itemInfo.tags.length; i++)
                {
                    if (itemInfo.tags[i].id == 11)
                    {
                        this.stoffparent = 'parent';
                    }
                }
            }
        }
    },

    computed:
    {
        isSoldOut()
        {
            return this.item.variation.availability.id == 5
                && ((this.stoffparent == null || this.stoffparent != 'parent')
                    || (this.item.variation.minimumOrderQuantity > this.item.stock.net && this.stoffparent != 'parent'))
                && this.item.item.stockLimitation != 1;
        },

        item()
        {
            return this.itemData || this.itemSlotData || this.itemDataRef;
        },

        itemSlotData: getSlotData('item-data'),

        /**
         * Herstellername für die Anzeige; null, wenn der Hersteller auf der
         * Sperrliste steht (analog Snaply). Hat Vorrang vor der Farben-Anzeige.
         */
        showproducer()
        {
            const itemInfo = this.item && this.item.item;

            if (!itemInfo || !itemInfo.manufacturer)
            {
                return null;
            }

            const listNotToShow = [
                "Markenlos",
                "AA Stoffe für Sortierung",
                "Projekte Showroom",
                "Snaply",
                "Produktionsartikel",
                "NICHT NOSTO",
                "Sortierung Erscheinungsdatum",
                "Lovely Casa",
                "Kretzer",
                "Lang Yarn",
                ""
            ];

            if (listNotToShow.indexOf(itemInfo.manufacturer.name) > 0)
            {
                return null;
            }

            return itemInfo.manufacturer.name;
        },

        /**
         * returns itemData.item.storeSpecial
         */
        storeSpecial()
        {
            return this.item.item.storeSpecial;
        },

        /**
         * returns itemData.texts
         */
        texts()
        {
            return this.item.texts;
        },

        itemPrice()
        {
            return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
        },

        basePrice()
        {
            return this.item.prices.default.basePrice;
        },

        itemPriceGraduated()
        {
           let unitPrice;
           if (App.config.item.enableGraduatedPrices) {
             unitPrice = this.item.prices.graduatedPrices.length > 0
                 ? this.item.prices.graduatedPrices[0].unitPrice
                 : this.item.prices.default.unitPrice;
           } else {
             unitPrice = this.item.prices.default.unitPrice;
           }

            return this.$options.filters.specialOffer(unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
        },

        itemGraduatedPriceisCheapestSorting()
        {
            return !!this.item.item && this.item.item.salableVariationCount > 1 && !!this.$ceres.isCheapestSorting;
        },

        itemGraduatedPricesalableVariationCount()
        {
            return !!this.item.item && this.item.item.salableVariationCount == 1 && this.item.prices.graduatedPrices.length > 1 && App.config.item.enableGraduatedPrices;
        },

        itemSetPrice()
        {
            return this.$options.filters.currency(
                this.item.prices.default.price.value,
                this.item.prices.default.currency
            );
        },

        urlWithVariationId()
        {
            return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
        },

        hasCrossPrice() {
            const hasRrpPrice = !!this.item.prices.rrp &&
                this.item.prices.rrp.unitPrice.value > this.item.prices.default.unitPrice.value;

            const hasBeforePrice = !!this.item.prices.specialOffer &&
                !!this.item.prices.default &&
                this.item.prices.default.unitPrice.value > this.item.prices.specialOffer.unitPrice.value;

            return hasRrpPrice || hasBeforePrice;
        },

        ...mapState({
            showNetPrices: state => state.basket.showNetPrices
        })
    }
}
</script>
